import { Heart } from "lucide-react";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-card border-t border-border py-8 mt-auto">
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
                    <div className="flex items-center gap-1">
                        <span>Copyright &copy; {currentYear}</span>
                        <a
                            href="https://www.ppu.edu"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary hover:underline font-medium"
                        >
                            ppu.edu
                        </a>
                    </div>

                    <div className="flex items-center gap-2">
                        <span>Prepared by</span>
                        <span className="font-semibold text-foreground">Nidal Aljuneidi</span>
                        <span>Driven by</span>
                        <span className="font-semibold text-foreground">AI </span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
